import { CButton, CCallout, CCollapse } from "@coreui/react";
import { useState } from "react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import styled from "styled-components";

const StyledCallout = styled(CCallout)`
  li::marker {
    color: #2eb85c !important;
    font-size: 40px !important;
  }
  li {
    max-width: 400px;
  }

  background-color: white;

  .c-dark-theme & {
    background-color: #2b2b2b;
    color: white;
  }

`;

const InfoCollapse = ({
  title,
  children,
  style = {},
  className = "",
  defaultOpen = false,
  titleFontSize = "16px",
  ...rest
}) => {
  const [showCollapse, setShowCollapse] = useState(defaultOpen);

  return (
    <StyledCallout
      color="success"
      className={"position-relative shadow"}
      style={{
        ...style,
        // backgroundColor: "white",
        padding: 0,
        width: "100%",
        maxWidth: "600px",
      }}
      {...rest}
    >
      {" "}
      <CButton
        variant="ghost"
        color="success"
        className="w-100 d-flex justify-content-between align-items-center px-2 text-left "
        onClick={() => setShowCollapse((prev) => !prev)}
        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      >
        <span
          style={{ fontSize: titleFontSize, color: "black" }}
          className="m-0 text-black "
        >
          <AiOutlineQuestionCircle size={20} className="mb-1" /> {title}
        </span>
        {showCollapse ? (
          <IoMdArrowDropup fontSize={20} />
        ) : (
          <IoMdArrowDropdown fontSize={20} />
        )}
      </CButton>
      <CCollapse show={showCollapse} className="p-3 pl-5 ">
        {children}
      </CCollapse>
      {showCollapse && (
        <div
          style={{
            backgroundColor: "#2eb85c",
            position: "absolute",
            top: 77,
            left: 62,
            height: "85%",
            width: "2px",
          }}
        />
      )}
    </StyledCallout>
  );
};

export default InfoCollapse;
